import { Container, Row, Col } from "react-bootstrap";
import 'animate.css';
import '../css/Partnerships.css';
import TrackVisibility from 'react-on-screen';
import { FaRegDotCircle } from 'react-icons/fa';
import amazonLogo from "../assets/logo/Amazon-Logo.wine.svg";
import facebookeLogo from "../assets/logo/Facebook-Logo.wine.svg";
import googleLogo from "../assets/logo/Google-Logo.wine.svg";
import tiktokLogo from "../assets/logo/TikTok-Logo.wine.svg";
import youtubeogo from "../assets/logo/YouTube-Logo.wine.svg";
import cpsImg from '../assets/partnerships/cps.png';
import brandImg from '../assets/partnerships/brand.png';
import affiliateImg from '../assets/partnerships/affiliate.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';




export const Partnerships = () => {
  const content = {
    sectionTitle: "Creator Partnerships",
    PartnershipsProgram: {
      title: "Creator Partnerships Program",
      description: "Diverse collaboration models to help every creator maximize their content value.",
    },
    CollaborationSections: {
      title: "Brand Partnership Collaboration",
      icon: <FaRegDotCircle className="decorative-dot" />,
      text: `• Long-term strategic cooperation • Build exclusive commercial value
• Exclusive Partnership: MCN handles all business deals and provides exclusive content & brand collaboration resources.
• Non-Exclusive Partnership: Creators can accept external offers freely while receiving MCN resource support.
• Traffic Incubation Model: MCN invests resources in early-stage creators to support growth and share long-term revenue.`,
      gradient: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
    },
    CPSSections: {
      title: "CPS Product Promotion Collaboration",
      icon: <FaRegDotCircle className="decorative-dot" />,
      text: `• Flexible product promotion · Performance-based commission · No contract required
• Join anytime, accept promotion offers flexibly.
• Freely choose products to promote.
• Earn high commissions based on actual sales.`,
      gradient: "linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%)"
    },
    AffiliateSections: {
      title: "Affiliate Marketing Collaboration",
      icon: <FaRegDotCircle className="decorative-dot" />,
      text: `• For private traffic owners · Easy traffic monetization
• Targeted at creators or publishers with their own private traffic pools.
• No contract required, operate independently.
• Receive exclusive affiliate links and earn commissions based on promotion performance.`,
      gradient: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
    },
    supportPolicy: {
      title: "Welfare and support policies",
      description:
        "Provide financial support, traffic support, priority resource allocation, etc. to help creators grow rapidly and enjoy multi-faceted resource tilt and commercial returns."
    }
  };


  // // Slick 设置
  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   centerMode: true,             // 启用居中模式
  //   slidesToShow: 3,              // 一次显示三个卡片
  //   centerPadding: '0',           // 去除默认左右内边距

  //   speed: 500,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   swipeToSlide: true,
  //   arrows: true,
  // }




  // 科技公司logo数据
  const techLogos = [
    { id: 1, src: amazonLogo, alt: "Amazon" },
    { id: 2, src: facebookeLogo, alt: "Facebook" },
    { id: 3, src: googleLogo, alt: "Google" },
    { id: 4, src: tiktokLogo, alt: "TikTok" },
    { id: 5, src: youtubeogo, alt: "YouTube" }
  ];

  // // 2. 配置 slick carousel 的参数
  // const sliderSettings = {
  //   dots: true,            // 显示轮播指示点
  //   infinite: true,       // 是否无限循环
  //   speed: 500,            // 切换速度
  //   slidesToShow: 1,       // 每次显示一张
  //   slidesToScroll: 1,     // 每次滚动一张
  //   swipeToSlide: true,    // 允许拖拽滑动
  //   draggable: true,       // 启用鼠标拖动
  //   arrows: true,         // 隐藏左右箭头
  //   // 你可以根据需要添加 autoplay, fade 等更多配置
  // };








  return (
    <section className="partnerships-section" id="partnerships">
      <Container className="custom-container">
        {/* 标题及 Logo 部分 */}
        <div className="section-bx wow slideInUp">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center mb-5">
              <TrackVisibility>
                {({ isVisible }) => (
                  <h2
                    className={`section-title ${isVisible ? "animate__animated animate__fadeInDown" : ""
                      }`}
                  >
                    {content.sectionTitle}
                  </h2>
                )}
              </TrackVisibility>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-5">
            {techLogos.map((logo) => (
              <Col key={logo.id} xs={2} sm={2} md={2} className="text-center">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="tech-logo"
                  style={{ width: "100%", height: "80%", opacity: 0.7 }}
                />
              </Col>
            ))}
          </Row>
        </div>


        <div className="swiper-container">
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={3}
            initialSlide={1} // 默认从索引 1 开始，即中间的卡片
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}

            // pagination={true}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="card">
                <img src={cpsImg} alt="Nature 1" className="card-img" />
                <div className="card-content">
                  <h3>CPS Product Promotion</h3>
                  <p>Flexible · Performance-based commission · No contract required</p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="card">
                <img src={brandImg} alt="Nature 2" className="card-img" />
                <div className="card-content">
                  <h3>Brand Partnership Collaboration</h3>
                  <p>Exclusive &amp; Non-Exclusive, Traffic Incubation Model</p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="card">
                <img src={affiliateImg} alt="Nature 4" className="card-img" />
                <div className="card-content">
                  <h3>Affiliate Marketing Collaboration</h3>
                  <p>Easy traffic monetization for private traffic owners</p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>







        {/* <Row className="justify-content-center mt-5">
          <Col xl={10} lg={10} md={12}>
            <div className="program-card">
              <h2>{content.PartnershipsProgram.title}</h2>
              <p>{content.PartnershipsProgram.description}</p>
            </div>
          </Col>
        </Row>


      <Row className="justify-content-center">
          <Col xl={10} lg={10} md={12}>
            <Slider {...sliderSettings}>
              <div>
                <div
                  className="partnership-card"
                  style={{ background: content.CollaborationSections.gradient }}
                >
                  <div className="decorative-border"></div>
                  <div className="content-wrapper">
                    <div className="icon-wrapper">
                      {content.CollaborationSections.icon}
                    </div>
                    <h3>{content.CollaborationSections.title}</h3>
                    <pre className="styled-content">
                      {content.CollaborationSections.text}
                    </pre>
                  </div>
                </div>
              </div>


              <div>
                <div
                  className="partnership-card"
                  style={{ background: content.CPSSections.gradient }}
                >
                  <div className="decorative-border"></div>
                  <div className="content-wrapper">
                    <div className="icon-wrapper">
                      {content.CPSSections.icon}
                    </div>
                    <h3>{content.CPSSections.title}</h3>
                    <pre className="styled-content">
                      {content.CPSSections.text}
                    </pre>
                  </div>
                </div>
              </div>

              <div>
                <div
                  className="partnership-card"
                  style={{ background: content.AffiliateSections.gradient }}
                >
                  <div className="decorative-border"></div>
                  <div className="content-wrapper">
                    <div className="icon-wrapper">
                      {content.AffiliateSections.icon}
                    </div>
                    <h3>{content.AffiliateSections.title}</h3>
                    <pre className="styled-content">
                      {content.AffiliateSections.text}
                    </pre>
                  </div>
                </div>
              </div>
            </Slider>
          </Col>
        </Row> */}

        {/* <Row className="justify-content-center mt-5">
          <Col xl={10} lg={10} md={12}>
            <div className="policy-card">
              <h2>{content.supportPolicy.title}</h2>
              <p>{content.supportPolicy.description}</p>
            </div>
          </Col>
        </Row>
        <Row >
          <Slider {...settings}>
            <div className="card-container">
              <div className="card">
                <img src={cpsImg} alt="CPS Product Promotion" className="card-img" />
                <div className="card-content">
                  <h3>CPS Product Promotion</h3>
                  <p>Flexible · Competitive</p>
                </div>
              </div>
            </div>

            <div className="card-container">
              <div className="card">
                <img src={brandImg} alt="Brand Partnership" className="card-img" />
                <div className="card-content">
                  <h3>Brand Partnership Collaboration</h3>
                  <p>Exclusive/Non-Exclusive/Traffic Incubation</p>
                </div>
              </div>
            </div>

            <div className="card-container">
              <div className="card">
                <img src={affiliateImg} alt="Affiliate Marketing" className="card-img" />
                <div className="card-content">
                  <h3>Affiliate Marketing</h3>
                  <p>Independent · Contract-free · Floating commission</p>
                </div>
              </div>
            </div>
          </Slider>
        </Row> */}








      </Container>

      <div className="section-divider"></div>
    </section>
  );
};
